// web/src/api/privacy.ts — Phase 5 D-06 / PRIV-05.
//
// Typed fetch wrappers for /api/config/privacy. Mirrors the Go handler
// shipped in plan 05-01 (internal/httpx/config_privacy.go). The PUT side
// is CSRF-protected via withCSRF() per Phase-1 D-14 double-submit.
//
// Pre-login GET is rejected by RequireSession (returns 401); the screen
// catches the failure and redirects to /login.
import { type PrivacyConfig } from "../types/api.js";
import { withCSRF } from "./_csrf.js";

export async function getPrivacy(): Promise<PrivacyConfig> {
  const res = await fetch("/api/config/privacy", { credentials: "include" });
  if (!res.ok) throw new Error(`getPrivacy: ${res.status}`);
  return res.json() as Promise<PrivacyConfig>;
}

export async function setPrivacy(retention_enabled: boolean): Promise<PrivacyConfig> {
  const res = await fetch("/api/config/privacy", {
    method: "PUT",
    credentials: "include",
    headers: withCSRF({ "Content-Type": "application/json" }),
    body: JSON.stringify({ retention_enabled }),
  });
  if (!res.ok) throw new Error(`setPrivacy: ${res.status}`);
  return res.json() as Promise<PrivacyConfig>;
}
